// extracted by mini-css-extract-plugin
export default {"ambientLight":"ox_oy"};